import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ChangelogTimeline} from '~components/changelog/ChangelogTimeline';

export const Route = createFileRoute('/changelog')({
  component: ChangelogPage,
});

function ChangelogPage(): JSX.Element {
  return (
    <BaseLayout>
      <ChangelogTimeline />
    </BaseLayout>
  );
}
